/* eslint-disable @typescript-eslint/member-ordering */

import { _decorator, Enum, Animation, ccenum, CCFloat } from 'cc';
import { DEV, EDITOR } from 'cc/env';
import { setEnumAttr, hasSameEnumEntries } from '../../Utils/Utility';
import BaseAction from './BaseAction';

const { ccclass, property } = _decorator;

export enum DefaultAnimsEnum {
    '<None>' = 0,
}
ccenum(DefaultAnimsEnum);

// 動畫行為
export enum AnimationActionType {
    Play,
    Stop,
    None,
}

@ccclass('AnimationAction')
export default class AnimationAction extends BaseAction {
    @property({ type: Animation, displayName: DEV && '動畫元件', tooltip: DEV && 'Cocos 動畫元件 (Animation)' })
    public get displayAnimation() {
        return this.animation;
    }
    public set displayAnimation(value: Animation) {
        this.animation = value;
        this._refreshInspector();
    }
    @property({ type: Enum(AnimationActionType), displayName: DEV && '操作類型', tooltip: DEV && '要進行什麼行為' })
    public readonly type: AnimationActionType = AnimationActionType.Play;

    @property({
        displayName: DEV && 'Clip名稱',
        tooltip: DEV && '播放的AnimationClip名稱',
        type: DefaultAnimsEnum,
        visible(this: AnimationAction) {
            return !!this.animation;
        },
    })
    public get _animationIndex() {
        if (EDITOR) {
            this._syncInspectorEnums();
        }
        const { animationClipName } = this;
        if (this.animation) {
            if (animationClipName) {
                const animsEnum = this.animation.getClipsEnum();
                if (animsEnum) {
                    const animIndex = animsEnum[animationClipName];
                    if (animIndex !== undefined) {
                        return animIndex;
                    }
                }
            } else {
                this._refreshInspector();
            }
        }
        return 0;
    }
    public set _animationIndex(value: number) {
        let animsEnum = {};
        if (this.animation) {
            animsEnum = this.animation.getClipsEnum();
        }
        const animName = value === 0 ? '' : animsEnum[value];
        if (animName !== undefined) {
            this.animationClipName = animName;
            this._refreshInspector();
        }
    }
    @property({
        displayName: DEV && 'Clip名稱',
        tooltip: DEV && '播放的AnimationClip名稱',
        visible(this: AnimationAction) {
            return !this.animation;
        },
    })
    public animationClipName: string = '';
    @property({ displayName: DEV && '播放起始時間點', tooltip: DEV && '設置動畫應該從第幾毫秒開始播放' })
    public readonly startTime: number = 0;

    @property({ displayName: DEV && '調整播放速度', tooltip: DEV && '是否要變動播放速度' })
    public readonly updateSpeedRate: boolean = false;
    @property({
        displayName: DEV && '播放速度',
        tooltip: DEV && '播放速度倍率',
        type: CCFloat,
        visible(this: AnimationAction) {
            return this.updateSpeedRate;
        },
    })
    public speedRate: number = 1;

    @property({
        visible: false,
        serializable: true,
    })
    public animation: Animation = null;

    @property({
        displayName: DEV && '接續播放',
        tooltip: DEV && '是否接續在當前動畫之後播放 (AddAnimation)\n若當前動畫是循環表演則無法進入此動畫',
        visible(this: AnimationAction) {
            return this.type === AnimationActionType.Play;
        },
    })
    public readonly isAddAnimation: boolean = false;

    @property({
        displayName: DEV && '中斷原有接續播放',
        tooltip: DEV && '是否接續在當前動畫該次循環之後播放 (AppendAnimation)',
        visible(this: AnimationAction) {
            return this.type === AnimationActionType.Play;
        },
    })
    public readonly isAppendAnimation: boolean = false;

    protected _enumAnimations: any = Enum({});

    private _refreshInspector() {
        this._updateAnimEnum();
    }

    private _getAnimEnumSource() {
        if (this.animation) {
            return this.animation.getClipsEnum();
        }
        return DefaultAnimsEnum;
    }

    private _updateAnimEnum() {
        const animEnum = this._getAnimEnumSource();
        this._enumAnimations = Enum({});
        Object.assign(this._enumAnimations, animEnum);
        Enum.update(this._enumAnimations);
        setEnumAttr(this, '_animationIndex', this._enumAnimations);
    }

    // 每次編輯器讀取列舉時檢查來源是否有變化，避免只在名稱為空或 setter 執行時才刷新，
    // 導致載入時名稱已經有效的實例一直停留在快取的 <None>。
    private _syncInspectorEnums() {
        if (!hasSameEnumEntries(this._getAnimEnumSource(), this._enumAnimations)) {
            this._updateAnimEnum();
        }
    }
}
